/**
 * @flow
 */

/* eslint-disable */

'use strict';


/*::
import type { ReaderFragment } from 'relay-runtime';
export type DevelopmentRegistrationStep = "first_buyer" | "result" | "second_buyer" | "verification";
import type { FragmentReference } from "relay-runtime";
declare export opaque type DevelopmentSecondBuyerStep_form$ref: FragmentReference;
declare export opaque type DevelopmentSecondBuyerStep_form$fragmentType: DevelopmentSecondBuyerStep_form$ref;
export type DevelopmentSecondBuyerStep_form = {|
  +id: string,
  +step: ?DevelopmentRegistrationStep,
  +secondBuyerFirstName: ?string,
  +secondBuyerLastName: ?string,
  +secondBuyerDateOfBirth: ?string,
  +secondBuyerPhoneNumber: ?string,
  +secondBuyerSavings: ?number,
  +secondBuyerAnnualRevenues: ?number,
  +secondBuyerNationality: ?{|
    +id: string,
    +name: string,
  |},
  +secondBuyerOccupation: ?{|
    +id: string
  |},
  +secondBuyerWorkPermit: ?{|
    +id: string
  |},
  +$refType: DevelopmentSecondBuyerStep_form$ref,
|};
export type DevelopmentSecondBuyerStep_form$data = DevelopmentSecondBuyerStep_form;
export type DevelopmentSecondBuyerStep_form$key = {
  +$data?: DevelopmentSecondBuyerStep_form$data,
  +$fragmentRefs: DevelopmentSecondBuyerStep_form$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  (v0/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DevelopmentSecondBuyerStep_form",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "step",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "secondBuyerFirstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "secondBuyerLastName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "secondBuyerDateOfBirth",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "secondBuyerPhoneNumber",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "secondBuyerSavings",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "secondBuyerAnnualRevenues",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Dictionary",
      "kind": "LinkedField",
      "name": "secondBuyerNationality",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Dictionary",
      "kind": "LinkedField",
      "name": "secondBuyerOccupation",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Dictionary",
      "kind": "LinkedField",
      "name": "secondBuyerWorkPermit",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": null
    }
  ],
  "type": "DevelopmentRegistrationForm",
  "abstractKey": null
};
})();
// prettier-ignore
(node/*: any*/).hash = '27cbc989adaa06f34fecf61b7f686b61';

export default node;
